export default "__VITE_ASSET__FVstajqw__"